module.exports = __webpack_public_path__ + "static/media/home-1920.71433b81.jpg";